import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../variants";
import { FaGithub } from "react-icons/fa";
import Img1 from "../assets//amazone_UI-Web.png";
import Img2 from "../assets/weatherapp.png";
import Img3 from "../assets/blog.png";

const PortFolio = () => {
  return (
    <section className="section" id="portfolio">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-x-10">
          <motion.div
            variants={fadeIn("right", 0.2)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0 lg:gap-y-10"
          >
            <div>
              <h2 className="h2 leading-tight text-accent">
                My Latest <br />
                Project
              </h2>
              <p className="max-w-sm mb-16">
                I made these projects because I'm passionate in learning web
                architecture and its foundations.
              </p>
              <a href="https://github.com/gaudakash" target="_blank">
                <button className="btn btn-sm flex justify-center items-center gap-x-2">
                  view project on <FaGithub />
                </button>
              </a>
            </div>
            <div className="group relative overflow-hidden border-2 border-white/50 rounded-xl xl:h-64 lg:h-56">
              <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300" />

              <img
                className="group-hover:scale-125 transition-all duration-500"
                src={Img1}
                alt=""
              />
              <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50">
                <span className="text-gradient">Firebase Deploye</span>
              </div>
              <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                <span className="text-3xl">Amazone UI Web</span>
              </div>
              <div className="absolute -bottom-full right-12 group-hover:bottom-14 transition-all duration-700 z-50">
                <a href="https://a-clone-56fb8.web.app/" target="_blank">
                  <button className="btn btn-sm  text-1xl border p-3 ">
                    Live View
                  </button>
                </a>
              </div>
            </div>
          </motion.div>

          {/*2nd  and 3rd box project*/}
          <motion.div
            variants={fadeIn("left", 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 flex flex-col justify-between max-sm:gap-y-10 "
          >
            <div className="group relative overflow-hidden border-2 border-white/50 rounded-xl xl:h-64 lg:h-56">
              <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300" />

              <img
                className="group-hover:scale-125 transition-all duration-500"
                src={Img2}
                alt=""
              />
              <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50">
                <span className="text-gradient">Js & React Projects</span>
              </div>
              <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                <span className="text-3xl">Weather App</span>
              </div>
              <div className="absolute -bottom-full right-12 group-hover:bottom-14 transition-all duration-700 z-50">
                <a
                  href="https://weatherapp-gaudaakash.vercel.app/"
                  target="_blank"
                >
                  <button className="btn btn-sm  text-1xl border p-3 ">
                    Live View
                  </button>
                </a>
              </div>
            </div>
            {/* 3rd box */}

            <div className="group relative overflow-hidden border-2 border-white/50 rounded-xl xl:h-64 lg:h-56">
              <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300" />

              <img
                className="group-hover:scale-125 transition-all duration-500"
                src={Img3}
                alt=""
              />
              <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50">
                <span className="text-gradient">Wordpress</span>
              </div>
              <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                <span className="text-3xl">Blog Site</span>
              </div>
              <div className="absolute -bottom-full right-12 group-hover:bottom-14 transition-all duration-700 z-50">
                <a href="/" target="_blank">
                  <button className="btn btn-sm  text-1xl border p-3 ">
                    Live View
                  </button>
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PortFolio;
